import { useState, useCallback } from "react";

const useFetch = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const resetUseFetchState = useCallback(() => {
    setError(null);
    setData(null);
    setIsLoading(false);
  }, []);

  const fetchData = useCallback(
    async (url, typeOfRequest = "GET", body = null, signal, withCredentials = false) => {
      setData(null);
      setError(null);
      setIsLoading(true);

      const reqObject = {
        method: typeOfRequest,
        body: body ? JSON.stringify(body) : null,
        signal,
      };

      if (typeOfRequest === "POST") {
        reqObject.headers = { "Content-Type": "application/json" };
      }

      if (withCredentials) {
        reqObject.credentials = "include";
      }

      try {
        const response = await fetch(url, reqObject);
        const json = await response.json();

        if (!response.ok) {
          throw new Error(
            json.message || `HTTP error! status: ${response.status}`,
          );
        }

        setData(json);
        return true;
      } catch (error) {
        setError(error);
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  return { data, error, isLoading, fetchData, resetUseFetchState };
};

export default useFetch;
